<template>
    <div class="text-[#2b2b2b]">
        <div class="mb-4">
            <h2 class="text-4xl">Mettre à jour l'objectif</h2>
        </div>

        <div class="p-4 text-[#2b2b2b] bg-white rounded-lg">
            <form @submit.prevent="updateTask" class="mt-3 flex flex-col gap-y-10 w-1/2">
                <div class="flex flex-col gap-y-1">
                    <label for="evoluttion" class="font-extralight text-[16px]">Evolution</label>
                    <div class="flex items-center gap-x-8">
                        <input v-model="form.percentage" type="range" id="evoluttion" name="evoluttion" step="5" min="0" max="100" />
                        <span class="w-[15%]">{{ form.percentage }} %</span>
                    </div>
                </div>
                <div class="flex flex-col gap-y-1">
                    <label for="commentaire" class="font-extralight text-[16px]">Commentaire</label>
                    <textarea v-model="form.user_comment" name="commentaire" id="commentaire" placeholder="Commentaire" class="min-h-[150px] border rounded-lg p-3"></textarea>
                </div>
                <button type="submit" class="text-white bg-[#3c41e9] rounded-lg h-[40px] w-full flex items-center justify-center">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Ajouter un objectif</span>
                </button>
            </form>
            <div class="h-10"></div>
        </div>
    </div>
</template>
<script>
import API from '@/service/API';
import {
    Loader2
} from "lucide-vue-next";
import toast from '@/components/ui/toast';
export default {
    name : "UpdateTaskView",
    components:{Loader2},
    props:[],
    data(){
        return {
            asSend:false,
            id:"",
            form:{
                percentage:0,
                user_comment:"",
                user_id: localStorage.getItem("userId")
            }
        }
    },
    created(){
        this.id = this.$route.params.taskId;
        this.form.percentage = this.$route.params.percentage;
    },
    methods:{
        clearForm(){
            this.form = {
                percentage:this.form.percentage,
                user_comment:"",
                user_id: localStorage.getItem("userId")
            }
        },
        updateTask(){
            if(this.$route.params.percentage > this.form.percentage){
                toast.error("La valeur de la mise à jour doit être supérieure à la valeur actuelle");
                this.asSend = false;
                return;
            }
            this.asSend = true;
            API.post("/updates", {
                user_comment: this.form.user_comment,
                percentage: this.form.percentage,
                type: "UPDATE",
                // goal_id: this.id
            })
                .then((response) => {
                    if(response.data.status == 200 || response.data.status == 201){
                        toast.success("Objectif mis à jour avec succès");
                        this.clearForm();
                    }else{
                        toast.error("Erreur lors de la mise à jour de l'objectif");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Erreur lors de la mise à jour de l'objectif");
                })
                .finally(() => {
                    this.asSend = false;
                });
        }
    }
}
</script>